<span class="copyright-item">© {{currentYear}} Lexi.Market</span>
<a class="copyright-item" href="mailto:{{mailTo}}">{{mailTo}}</a>